import type {EagColumnState} from '../../../../../types/EagColumnState';

/**
 * Returns `columnStates` with `hidden` set to `hidden` on the columns in
 * `eligibleKeys` whose visibility differs. Every other entry keeps its
 * identity, and `lockedHidden` (definition-hidden) columns are never touched,
 * so a batch that changes nothing costs the store no churn.
 */
export const applyColumnsVisibility = (
  columnStates: EagColumnState[],
  eligibleKeys: Set<string>,
  hidden: boolean
): EagColumnState[] =>
  columnStates.map((columnState) => {
    const isEligible = eligibleKeys.has(columnState.key) && columnState.lockedHidden !== true;
    return isEligible && (columnState.hidden ?? false) !== hidden
      ? {...columnState, hidden}
      : columnState;
  });
